'use strict';

var axios = require('axios');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);

/**
 * @file 基础方法封装
 * @author weizhongqiang@baidu.com
 */

function getLocalStorage(key) {
    return window.localStorage.getItem(key) ? JSON.parse(window.localStorage.getItem(key)) : '';
}

function setLocalStorage(key, value) {
    window.localStorage.setItem(key, JSON.stringify(value));
}

/**
 * 解析网页url
 * @param {string} path url
 */

/* istanbul ignore next */
function getFullPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    let href = window.location.href;
    const index = href.indexOf('#');
    // empty path
    if (index < 0) {
        return '';
    }

    href = href.slice(index + 1);
    // decode the hash but not the search or hash
    // as search(query) is already decoded
    // https://github.com/vuejs/vue-router/issues/2708
    const searchIndex = href.indexOf('?');
    if (searchIndex < 0) {
        const hashIndex = href.indexOf('#');
        if (hashIndex > -1) {
            href = decodeURI(href.slice(0, hashIndex)) + href.slice(hashIndex);
        } else {
            href = decodeURI(href);
        }
    } else {
        if (searchIndex > -1) {
            href = decodeURI(href.slice(0, searchIndex)) + href.slice(searchIndex);
        }
    }

    return href;
}

/**
 * 解析url
 */
/* istanbul ignore next */
function parsePath(path) {
    path = path || getFullPath();
    let hash = '';
    let query = '';

    const hashIndex = path.indexOf('#');
    if (hashIndex >= 0) {
        hash = path.slice(hashIndex);
        path = path.slice(0, hashIndex);
    }

    const queryIndex = path.indexOf('?');
    if (queryIndex >= 0) {
        query = path.slice(queryIndex + 1);
        path = path.slice(0, queryIndex);
    }


    return {
        path,
        query,
        hash
    };
}

/**
 * @file: util
 * @author: yangtianjiao@baidu.com
 * @Date: 2019-07-30 18:10:13
 * @Description: 工具
 */

var util = {
    // 空函数
    noop() {},


    /**
     * 新开窗口
     * @param {string} path 路由地址
     * @return {boolean} 无实义
     */
    openPage(path) {
        if (!path) {
            return false;
        }
        let fixedPath = window.location.href.split('#')[0];
        window.open(fixedPath + '#' + path);
    },

    /**
     * 关闭窗口并刷新父窗口
     * @param {string} path 路由地址
     */
    closePage() {
        window.close();
        opener.location.reload();
    },

    /**
     * 判断是否是数组
     * @param {Array} arr 待判断参数
     * @return {boolean}  是否
     */
    isArray(arr) {
        if (Array.isArray) {
            return Array.isArray(arr);
        }
        return Object.prototype.toString.call(arr) === '[object Array]';
    },

    /**
     * 判断是否是对象
     * @param {Object} obj 待判断参数
     * @return {boolean}  是否
     */
    isObj(obj) {
        return typeof obj === 'object';
    },

    /**
     * 判断是否是arr字符串
     * @param {string} str 待判断参数
     * @return {boolean}  是否
     */
    isArrStr(str) {
        try {
            let obj = JSON.parse(str);
            if (this.isArray(obj)) {
                return true;
            }
            else {
                return false;
            }
        } catch (e) {
            return false;
        }
    },

    /**
     * 判断是否是空对象
     * @param {Object} obj 待判断参数
     * @return {boolean}  是否
     */
    isEmptyObject(obj) {
        for (let key in obj) {
            return false;
        }
        return true;
    },

    /**
     * 处理表单数据，把级联型array转换为string
     * @param {Object} formData 处理前的参数
     * @return {Object} formaData
     */
    handleFormData(formData) {
        for (let key in formData) {
            if (this.isArray(formData[key])) {
                formData[key] = formData[key].length ? formData[key].pop() : '';
            }

            if (this.isObj(formData[key])) {
                formData[key] = JSON.stringify(formData[key]);
            }
        }
        return formData;
    },


    /**
     * 提示
     * @param {Object} me 当前实例
     * @param {string} msg 提示内容
     *  @param {string} type 提示类型
     * @param {Function} callback 回调
     * @param {boolean} isHtml 是否使用html
     *
     * @return {Function} 封装的alert实例
     */
    alert(me, msg, type, callback, isHtml) {
        return me.$alert(msg, '提示', {
            type,
            callback,
            dangerouslyUseHTMLString: isHtml || false
        });
    },

    /**
     * 错误弹窗
     *
     * @param {Object} me vue 实例
     * @param {*} res catch 的报错信息
     * @param {*} msg 默认的报错提示
     *
     * @return {Object} 封装的alert实例
     */
    alertErr(me, res, msg = '服务器开小差了～') {
        if (this.isArrStr(res.message)) {
            res.message = JSON.parse(res.message);
            let message = '<div>';
            message += res.message.join('<br>');
            message += '</div>';
            return this.alert(me, message || `${msg}`, this.noop, true);
        }
        return this.alert(me, res.message || `${msg}`);
    },

    /**
     * loading
     * @param {Object} me 当前实例
     * @param {string} msg 提示内容
     *
     * @return {Function} 封装的loading实例
     */
    loading(me, msg) {
        return me.$loading({
            lock: true,
            text: '',
            spinner: 'crm-loading'
        });
    },

    isWebSite(website) {
        /* eslint-disable*/
        const reg = /^(?=^.{3,255}$)(http(s)?:\/\/)(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/;
        return reg.test(website);
    },

    isTel(tel) {
        // const reg = /^\d{7,8}$/;
        const reg = /^\+?0\d{2,3}\d{7,8}$/g;
        return reg.test(tel);
    },

    isPhone(phone) {
        const reg = /^1[3456789]\d{9}$/;
        return reg.test(phone);
    },

    isEmail(str) {
        /* eslint-disable*/
        const reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
        return reg.test(str);
    },
    /**
     * 格式化时间
     *
     * @param {Object} date 日期对象
     * @param {string} fmt 格式
     * @return {string} value
     */
    formatDate(date, fmt) {
        var o = {
            'M+': date.getMonth() + 1,
            // 日
            'd+': date.getDate(),
            // 小时
            'h+': date.getHours(),
            // 分
            'm+': date.getMinutes(),
            // 秒
            's+': date.getSeconds(),
            // 季度
            'q+': Math.floor((date.getMonth() + 3) / 3),
            // 毫秒
            'S': date.getMilliseconds()
        };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
        }
        for (var k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) {
                fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
            }
        }
        return fmt;
    },
    /**
     `* 复制对象
     *
     * @param {Object} to 复制对象基础
     * @param {Object} from 复制来源
     * @return {Object} 返回合并后的对象
     */
    extend(to, from) {
        for (const key in from) {
            if (from.hasOwnProperty(key)) {
                to[key] = from[key];
            }
        }
        return to;
    },

    /**
     * 局部复制对象
     *
     * @param {Object} to 复制对象基础
     * @param {Object} from 复制来源
     * @return {Object} 返回合并后的对象
     */
    extendPart(to, from) {
        for (const key in to) {
            if (from.hasOwnProperty(key)) {
                to[key] = from[key];
            }
        }
        return to;
    },
    /**
     * 将map转换成Array
     *
     * @param {Object} from 复制来源
     * @return {Object} 返回Array类型数据
     */
    intotheArray(from, type) {
        if (from) {
            let objValueArr = Object.values(from);
            let obj = Object.keys(from).map((item, index) => {
                let itemObj = {};
                itemObj.value = +item;
                itemObj.label = objValueArr[index];
                return itemObj;
            });
            if (type) {
                let objList = obj.map(item => {
                     if(type === 'getText') {
                         return item.label;
                     }
                     else {
                         return +item.value;
                     }
                 });
                 return objList;
             }
             else {
                 return obj;
             }
        }
        else {
            return [];
        }
    },
    intotheMap(from) {
        // let objValueArr = Object.values(from);
        let obj = from.map((item, index) => {
            let val = item.key + ':' + item.value;
            return val;
        });
        return obj;
    },
    // 获取cookie
    getCookie(name) {
        let arr,reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        return (arr=document.cookie.match(reg))?unescape(arr[2]) : '';
    },
    /**
     * log 埋点方法
     * @param {string} pageId 页面id
     * @param {string} eventKey 自定义事件key
     * @param {Object} otherParams 其他参数，比如self等，详情见http://agroup.baidu.com/cop_fe/md/article/1748809
     */
    log(pageId, eventKey, otherParams = {}) {
        const prot = window.location.protocol;
        try {
            const url = `${prot}//aifanfan.baidu.com/s.gif`;
            let osMap = {
                'Win32': 3,
                'MacIntel': 4
            };
            // 主账号取uc_id（和login_id的主账号一致）， 子账号取acctId
            let loginId = this.getCookie('login_id') || '0:0';
            let SUBUSERID = Number(loginId.split(':')[1]) || 0;
            let USERID = Number(loginId.split(':')[0]) || 0;
            let acctId = +this.getCookie('acctId') || 0;
            let userId = SUBUSERID == 0 ? USERID : acctId;
            let params = {
                pageId,
                eventKey,
                userId,
                time: new Date().getTime(),
                env: 'WEB',
                sourceId: 'aff',
                osType: osMap[navigator.platform] || '',
                referrer: document.referrer || '',
                browser: this.getBrowserCore(),
                notVersion: true,
                ...otherParams
            };
            this.sendLog(url, params);
        } catch (e) {}    },
    // 获取浏览器信息
    getBrowserCore() {
        const userAgent = navigator.userAgent;
        const isOpera = userAgent.indexOf('Opera') > -1;
        if (isOpera) {
            return 'Opera';
        }
        if (userAgent.indexOf('Firefox') > -1) {
            return 'Firefox';
        }
        if (userAgent.indexOf('Chrome') > -1) {
            return 'Chrome';
        }
        if (userAgent.indexOf('Safari') > -1) {
            return 'Safari';
        }
        if (userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera) {
            return 'IE';
        }
        return 'others';
    },
     // 判断设备
     osType() {
        let ua = window.navigator.userAgent.toLowerCase();
        let isWindows = (ua.indexOf('windows') >= 0);
        let isMac = (ua.indexOf('mac') >= 0 && ua.indexOf('mobile') < 0);
        let isIOS = (ua.indexOf('mac') >= 0 && ua.indexOf('mobile') >= 0);
        let isAndroid = (ua.indexOf('android') >= 0);
        let os = isWindows ? 'windows'
            : isMac ? 'mac'
                : isIOS ? 'ios'
                    : isAndroid ? 'android'
                    : '';
        return os;
    },
    /**
     * 埋点sendLog函数
     * @param {string} url 埋点url
     * @param {*} param 埋点参数
     * @param {*} cb 回调函数
     */
    sendLog(url, param, cb) {
        let id = Date.now();
        let imgObj = window[id] = new Image();
        let timer = null;
        let imgParams = '';

        imgObj.onload = imgObj.onerror = imgObj.onabort = () => {
            window[id] = null;
            if (timer) {
                clearTimeout(timer);
                cb && cb();
            }
        };

        for (let i in param) {
            if (param[1] !== '') {
                imgParams += `&${i}=${encodeURIComponent(param[i])}`;
            }
        }

        imgObj.src = url + '?' + imgParams.slice(1);

        if (typeof cb === 'function') {
            timer = setTimeout(
                () => {
                    timer = null;
                    cb && cb();
                }, 500
            );
        }
    },
    getLocaltonParam() {
        let name = '';
        let value = '';
        let obj = {};
        let str = location.href;
        let num = str.indexOf("?");
        str = str.substr(num + 1);
        let arr = str.split("&");
        for (let i = 0; i < arr.length; i++) {
            num = arr[i].indexOf("=");
            if (num > 0) {
                name = arr[i].substring(0, num);
                value = arr[i].substr(num + 1);
                obj[name] = value;
            }
        }
        return obj;
    },
    /**
     * 表单验证可输入长度
     *
     * @param {number} l 最大长度
     * @return {Object}
     */
    validateLengthMAX(l) {
        return function (rule, val, cb) {
            if (val === '') {
                return cb(new Error('必填项不得为空'));
            }
            if (val.length > l) {
                return cb(new Error('最多输入' + l + '个字符'));
            }
            return cb();
        }
    },
    // 表单验证手机号
    validatePhone() {
        return function(rule, val, cb) {
            if (!val) {
                return cb(new Error('电话号码不得为空'));
            } else if (!(/^\d+$/).test(val)) {
                return cb(new Error('请输入正确的电话号码'));
            } else if (!(/^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/).test(val)) {
                return cb(new Error('请输入正确的电话号码'));
            } else {
                cb();
            }
        }
    },
    // 校验注册资本
    validRegisteredCapital(start, end) {
        let min = 0;
        let max = 1e10;
        if (start === '' && end === '') {
            return '';
        }
        else if (isNaN(start) || isNaN(end)) {
            return '只能输入数字';
        }
        else if ((start !== '' && end === '') || (end !== '' && start === '')) {
            if (start !== '' && !(+start > min && +start < max) || end !== '' && !(+end > min && +end < max)) {
                return '只能输入0-10,000,000,000 万元之间的数值';
            }
        }
        else if (!(+start > min && +start < max && +end > min && +end < max)) {
            return '只能输入0-10,000,000,000 万元之间的数值';
        }
        let reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
        let startflag = reg.test(start);
        let endflag = reg.test(end);
        reg.lastIndex = 0;
        if (start&&!startflag || end&&!endflag) {
            return '最多只能输入2位小数';
        }
        if (start&&end&&+start > +end) {
            return '后一个输入框值不能小于前一个';
        }
        return '';
    },
    // 通过时间戳获取倒计时
    getInterval(faultDate, completeTime) {
        let stime = Date.parse(new Date(faultDate));
        let etime = Date.parse(new Date(completeTime));
        let usedTime = etime - stime;  //两个时间戳相差的毫秒数
        let days = Math.floor(usedTime/(24*3600*1000));
        //计算出小时数
        let leave1 = usedTime%(24*3600*1000);    //计算天数后剩余的毫秒数
        let hours = Math.floor(leave1/(3600*1000));
        //计算相差分钟数
        let leave2 = leave1%(3600*1000);        //计算小时数后剩余的毫秒数
        let minutes = Math.floor(leave2/(60*1000));
        let timeStr = days + "天" + hours + "时" + minutes + "分";
        return {
            timeStr,
            timeObj: {
                days,
                hours,
                minutes
            }
        };
    },
    /**
     * 图片压缩
     * @param {Object} file  文件
     * @param {number} maxSize 文件大小(KB)
     * @param {Function} callback 回调
     */
    compressImg(file, maxSize, callback) {
        // console.log(file);
        let util = this;
        // if (/png/.test(file.type)) {
        //     maxSize = maxSize / 12;
        // }
        maxSize = maxSize * 1024;
        if (file.size < maxSize) {
            console.log('-----不需要压缩-----');
            if (callback) {
                callback(file);
            }
            return;
        }
        console.log('-----图片压缩开始-----');
        let img = new Image();
        let blobURL = URL.createObjectURL(file);
        img.src = blobURL;
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        img.onload = function () {
            let w = img.width > 1080 ? 1080 : img.width;
            let h = img.height > 1080 ? 1080 : img.height;
            canvas.width = w;
            canvas.height = h;
            ctx.clearRect(0, 0, w, h);
            ctx.drawImage(img, 0, 0, w, h);

            let baseQuality = 1;
            getBase64();

            function getBase64() {
                // canvas.toBlob(function (blob) {
                //     console.log(blob);
                //     baseQuality = (baseQuality * 100 - 20) / 100;
                //     if (blob.size > maxSize) { // 不符合要求，继续压
                //         getBlob(baseQuality);
                //         return;
                //     } else {
                //         console.log('-----图片压缩结束-----');
                //         let eFile = new File([blob], file.name, {
                //             type: file.type
                //         });
                //         if (callback) {
                //             callback(eFile);
                //         }
                //     }
                // }, 'image/jpeg', baseQuality);
                baseQuality = (baseQuality * 100 - 20) / 100;
                let base64file = canvas.toDataURL('image/jpeg', baseQuality);
                let size = util.getImgSize(base64file);
                if (size > maxSize) {
                    getBase64();
                    return;
                } else {
                    console.log(size);
                    console.log('-----图片压缩结束-----');
                    let tFile = util.dataURLtoFile(base64file, file);
                    callback(tFile);

                    // 文件格式不太对，重新画canvas转化
                    // let tImg = new Image();
                    // tImg.src = base64file;
                    // tImg.onload = function() {
                    //     // console.log('文件格式不太对，重新画canvas转化');
                    //     ctx.clearRect(0, 0, w, h);
                    //     ctx.drawImage(tImg, 0, 0, w, h);
                    //     let newBase64 = canvas.toDataURL(file.name);
                    //     let tFile = util.dataURLtoFile(newBase64, file);
                    //     callback(tFile);
                    // }
                }
            }
        };
    },
    /**
     * 获取base64图片大小，返回KB数字
     * @param {string} base64url base64字符串
     * @returns 文件大小（B）
     */
    getImgSize(base64url) {
        //获取base64图片大小，返回KB数字
        let str = base64url.replace('data:image/jpeg;base64,', ''); // 这里根据自己上传图片的格式进行相应修改

        let strLength = str.length;
        let fileLength = parseInt(strLength - (strLength / 8) * 2);

        let size = "";
        size = (fileLength).toFixed(2);

        return parseInt(size);

    },
    /**
     * base64 => file
     * @param {string} dataurl base64字符串
     * @param {Object} file 文件对象
     */
    dataURLtoFile(dataurl, file) {
        let arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
	        bstr = atob(arr[1]),
	        n = bstr.length,
	        u8arr = new Uint8Array(n);
	    while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        // console.log(dataurl);
        let fileName = file.name.replace(/\.\w+$/, '.jpeg');
	    return new File([u8arr], fileName, {type: mime});
    },
    // 判断数组中的元素是否重复出现
    // 验证重复元素，有重复返回true；否则返回false 
    arrCheckRepeat(arr) {
        let hash = {};
        for(var i in arr) {
            if(hash[arr[i]]) {
                return true;
            }
            hash[arr[i]] = true;
        }
        return false;
    },
    // 清空cookie
    clearCookie() {
        let cookieArr = document.cookie.split(';');
        cookieArr.forEach(item => {
            let [key] = item.split('=');
            let d = new Date();
            d.setDate(d.getDate() - 1);
            document.cookie = `${key}='';expires=${d};path=/`;
        });
    },
    // 生成guid
    guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    },
    /**
     * 转化日期 YYYYMMDD
     *
     * @param {Function} to 日期 new Date()
     * @param {String} from 分割符号类型，如 - / .
     * @return {Object} 返回日期 如 20200101
     */
    formatDate(date, type) {
        let myyear = date.getFullYear();
        let mymonth = date.getMonth() + 1;
        let myweekday = date.getDate();
        if (mymonth < 10) {
            mymonth = '0' + mymonth;
        }
        if (myweekday < 10) {
            myweekday = '0' + myweekday;
        }
        return (myyear + type + mymonth + type + myweekday);
    },
    /**
     * 计算当前日期前n天或者后n天日期
     *
     * @param {String} to 日期 如:'2020-01-01'
     * @param {String} from 参数，当前为0，前一天为-1，后一天为1
     * @param {String} from 分割符号类型，如 - / .
     * @return {Object} 返回日期 如 20200101
     */
    getBeforeDate(strDate, n, type){
        var datt = strDate.split('-');
        var newDate = new Date(datt[0], datt[1]-1, datt[2]);
        //计算前几天用减，计算后几天用加，最后一个就是多少天的数量
        var befminuts = newDate.getTime() + 1000 * 60 * 60 * 24 * parseInt(n);
        var beforeDat = new Date;
        beforeDat.setTime(befminuts);
        var befMonth = beforeDat.getMonth()+1;
        var mon = befMonth >= 10 ? befMonth : '0' + befMonth;
        var befDate = beforeDat.getDate();
        var da = befDate >= 10 ? befDate : '0' + befDate;
        var newDate = beforeDat.getFullYear() + type + mon + type + da;
        return newDate;
    }
};

/**
* @file ajax header
* @author yangtianjiao(yangtianjiao@baidu.com)
* @time 19.10.30
*/

const getCurrentPath = () => {
    const hash = window.location.hash;
    let path = '';
    if (hash && hash.length) {
        path = hash.charAt(0) === '#' ? hash.slice(1) : hash;
        path = path.split('?')[0];
    }
    return path;
};
// 获取cookie，设置请求头
var ajaxHeader = () => {
    let noWebPlatStatus = util.getCookie('clientType'); // 因为有部分页面嵌在PC客户端上，根据是否有这个cookie判定平台
    let arr = ['uc_id', 'acc_token', 'acc_id', 'login_id', 'device_type'];
    let headerObj = null;
    if (!noWebPlatStatus) {
        // web请求
        let [ucid, accToken, accId, loginId, deviceType] = arr.map(item => {
            let cookie = util.getCookie(item);
            cookie = cookie ? cookie.replace(/"/g, '') : '';
            return cookie;
        });
        headerObj = {
            'User-Info': `uc_id=${ucid};uc_appid=585;acc_token=${accToken};`
                + `acc_id=${accId};login_id=${loginId};device_type=${deviceType};paas_appid=1`,
            'Env': 'WEB',
            'Content-Type': 'application/json;charset=utf-8',
            'Api-Version': '0',
            'Client-Version': '0',
            'Auth-Type': 'PAAS',
            'x-source': getCurrentPath()
            // 'Request-Guid': util.guid()
        };
    }
    else {
        // PC客户端请求
        let ucid = util.getCookie('USERID');
        let token = util.getCookie('__cookies_token__');
        headerObj = {
            'User-Info': 'ucid=' + ucid + ';login_token=' + token,
            'Api-Version': 0,
            'Content-Type': 'application/json;charset=utf-8',
            'x-source': getCurrentPath()
        };
    }

    headerObj.pageGuid = (global || window).pageGuid;
    return headerObj;
};

const singleton = Symbol('apmSingleton');

/**
 * Apm（以下划线开头表示"私有"）
 */
class Apm {

    /**
     * 重写构造方法，避免手动创建实例绕过单例模式
     * @returns {*}
     */
    constructor() {
        const thisClass = this.constructor;
        if (!thisClass[singleton]) {
            thisClass[singleton] = this;
            this._init();
        }
        return thisClass[singleton];
    }

    /**
     * 只读单例
     * @returns {*}
     */
    static get instance() {
        if (!this[singleton]) {
            this[singleton] = new Apm();
        }
        return this[singleton];
    }

    /**
     * 检测当前业务环境
     * @returns {string} online表示线上环境，preonline表示预发布环境，qa表示测试环境
     * @private
     */
    get _environment() {
        const onlineOrPreOnline = process.env.VUE_APP_MODE === 'production';
        const preOnline = /aifanfan.baidu-int.com|pre-aifanfan.baidu.com|chuhaiyi-preonline.baidu-int.com/
            .test(window.location.hostname);
        return onlineOrPreOnline ? preOnline ? 'preonline' : 'online' : 'qa';
    };

    /**
     * 初始化
     */
    _init() {
        this._configOn();
        this._conf = {
            clusterUrls: [],
            urlMap: {}
        };
        this._optId = this.getNewId(); // 当前的optId
        // 调试模式，线上和预发布环境默认关闭，其他情况开启
        this._debugMode = this._environment !== 'online' && this._environment !== 'preonline';
        this._appType = 0; // 应用名称。默认为0，表示爱番番
        this._loginId = '';
    }

    /**
     * 配置apm是否开启
     * @private
     */
    _configOn() {
        if (this._environment === 'online' || this._environment === 'preonline') {
            let apmSwitch = getLocalStorage('apmSwitch');
            let apmRate = getLocalStorage('apmRate');
            apmSwitch = typeof apmSwitch === 'boolean' ? apmSwitch : false; // 开关，默认关闭
            apmRate = typeof apmRate === 'number' ? apmRate : 100; // 采样率，默认为100
            if (apmSwitch) {
                this._on = Math.random() * 100 <= apmRate; // apm（最终）是否开启
            } else {
                this._on = false;
            }
        } else { // 非线上和预发布环境apm始终开启
            this._on = true;
        }
        if (this._debugMode) {
            console.log('ApmLog ' + (this.on ? 'on' : 'off'));
        }
    }

    /**
     * 当前路由
     * @returns {*|string}
     * @private
     */
    _currentPath() {
        return parsePath().path || '';
    }

    /**
     * 设置sessionStorage
     * @param key {string}
     * @param value {*}
     */
    _setSessionStorage(key, value) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    /**
     * 获取sessionStorage
     * @param key {string}
     * @returns {any|string}
     */
    _getSessionStorage(key) {
        const value = sessionStorage.getItem(key);
        return value ? JSON.parse(value) : '';
    }

    /**
     * 对相同optId和segId的log进行聚合
     * @param seg {array} 相同optId和segId的log数组
     * @returns {*[]} 聚合后剩余的log数组
     * @private
     */
    _cluster(seg) {
        const segLength = seg.length;
        if (segLength <= 1) { // 符合条件的历史log只有不超过个，不必聚合
            return seg;
        }
        const clusteredIndexSet = new Set(); // 已聚合发送的log的index集合
        for (let curIndex = segLength - 1; curIndex >= 1; curIndex--) { // 倒序冒泡循环
            if (clusteredIndexSet.has(curIndex)) { // 该log已聚合时跳过
                continue;
            }
            const curLog = seg[curIndex];
            for (let preIndex = curIndex - 1; preIndex >= 0; preIndex--) {
                if (clusteredIndexSet.has(preIndex)) { // 该log已聚合时跳过
                    continue;
                }
                const preLog = seg[preIndex];
                const clusteredLog = this._clusterLog(curLog, preLog);
                if (clusteredLog) {
                    this._pushLog(clusteredLog);
                    clusteredIndexSet.add(curIndex);
                    clusteredIndexSet.add(preIndex);
                }
            }
        }
        return seg.filter((log, index) => {
            return !clusteredIndexSet.has(index);
        });
    }

    /**
     * 聚合两个日志
     * @param curLog {object} 当前日志
     * @param preLog {object} 历史日志
     * @returns {{login_id: (*|string), router: string, at: number, ot: (*|number), pu: (*|string), frt: number, apmpt: string, oid: *, segs: string[], o: number}|undefined}
     * @private
     */
    _clusterLog(curLog, preLog) {
        if (typeof curLog !== 'object' || typeof preLog !== 'object') { // log类型错误
            if (this._debugMode) {
                console.error('ApmLog clusterLog param log error', curLog, preLog);
            }
            return;
        }
        const curSegment = curLog.segment;
        const preSegment = preLog.segment;
        if (typeof curSegment !== 'object' || typeof preSegment !== 'object') { // segment类型错误
            if (this._debugMode) {
                console.error('ApmLog clusterLog param segment error', curLog, preLog);
            }
            return;
        }
        const curOptId = curLog.optId;
        const preOptId = preLog.optId;
        const curSegId = curSegment.segId;
        const preSegId = preSegment.segId;
        // optId或segId不相同
        if (!curOptId || !preOptId || !curSegId || !preSegId || curOptId !== preOptId || curSegId !== preSegId) {
            if (this._debugMode) {
                console.error('ApmLog cluster match error', curLog, preLog);
            }
            return;
        }
        const curTimeType = curSegment.timeType;
        const preTimeType = preSegment.timeType;
        if (+curTimeType + +preTimeType !== 1) { // timeType不匹配
            return;
        }
        const curTime = curSegment.time || 0;
        const preTime = preSegment.time || 0;
        // +curTimeType === 1表示curLog为结束日志，preLog为开始日志
        let startTime = +curTimeType === 1 ? preTime : curTime;
        let endTime = +curTimeType === 1 ? curTime : preTime;
        return this._assembleLog(curLog, startTime, endTime);
    }

    /**
     * 装配日志数据（字段定义参见：http://wiki.baidu.com/pages/viewpage.action?pageId=1352969778）
     * @param log {object} 原日志
     * @param startTime {number} 开始时间
     * @param endTime {number} 结束时间
     * @returns {{login_id: (*|string|string), router: string, at: number, ot: (*|number), pu: (*|string), frt: number, apmpt: string, oid: *, segs: string[], o: number}}
     * @private
     */
    _assembleLog(log, startTime, endTime) {
        const {segment} = log;
        const seg = {
            sid: segment.segId,
            styp: segment.segType || '',
            st: startTime,
            et: endTime,
            tags: segment.tags
        };
        const segString = JSON.stringify(seg);
        let osType = util.osType();
        if (osType === 'windows') {
            osType = 3;
        } else if (osType === 'mac') {
            osType = 4;
        } else {
            osType = 5;
        }
        const loginId = this._loginId || util.getCookie('login_id') || '';
        return {
            oid: log.optId, // 操作id
            ot: log.optType || 0, // 操作类型
            o: osType, // 系统类型
            frt: 4, // 框架类型
            at: this._appType, // 应用名称
            pu: log.pageUrl || '', // 页面英文名称
            apmpt: 'aff_apm_0', // 性能埋点类型
            login_id: loginId,
            router: 'APM', // 分流标识
            segs: [
                segString
            ]
        };
    }

    /**
     * 神策埋点
     * @param log {object}
     * @private
     */
    _pushLog(log) {
        if (this._debugMode) {
            console.log('ApmLog sensors', log);
        }
        window.sensors && window.sensors.track('Performance', log || {});
    }

    /**
     * 更新URL
     * @param url {string} pageUrl
     */
    _updateUrl(url) {
        // 映射
        if (this._conf.urlMap[url]) {
            url = this._conf.urlMap[url];
        }
        // 聚合
        if (this._conf.clusterUrls.length === 0) {
            return url;
        }
        this._conf.clusterUrls.forEach(path => {
            if (url.includes(path)) {
                url = path;
            }
        });
        return url;
    }

    /**
     * 获取Apm开启状态
     * @returns {boolean|*}
     */
    get on() {
        return this._on;
    };

    /**
     * 获取采样
     */
    loadSample() {
        try {
            // 非线上和预发布环境默认不使用采样，apm始终开启
            if (this._environment !== 'online' && this._environment !== 'preonline') {
                return;
            }
            setTimeout(() => {
                const url = '/crm/web/generic/bizConfig_query_queryConfig';
                const param = {
                    configName: 'apm_frontend_common_web'
                };
                axios__default["default"]({
                    url,
                    method: 'POST',
                    data: param,
                    headers: ajaxHeader,
                    timeout: 1000 * 30
                }).then(res => {
                    const configValues = res && res.data && res.data.data && res.data.data.configValues;
                    let apmSwitch = configValues && configValues.sampleRateSwitch;
                    let apmRate = configValues && configValues.sampleRateWeb;
                    apmSwitch = typeof apmSwitch === 'boolean' ? apmSwitch : false;
                    apmRate = typeof apmRate === 'number' ? apmRate : 100;
                    const first = getLocalStorage('apmSwitch') === ''; // 首次获取采样
                    setLocalStorage('apmSwitch', apmSwitch);
                    setLocalStorage('apmRate', apmRate);
                    if (first) { // 首次获取采样后重新配置apm开启状态
                        this._configOn();
                    }
                }).catch(err => {
                    if (this._debugMode) {
                        console.error('ApmLog load sample error', err);
                    }
                });
            }, 200);
        } catch (err) {
            if (this._debugMode) {
                console.error('ApmLog load sample catch error', err);
            }
        }
    }

    /**
     * 生成新的id
     * @returns {string} 新id
     */
    getNewId() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    /**
     * 获取当前的optId
     * @returns {string|*}
     */
    getOptId() {
        return this._optId;
    }

    /**
     * 设置当前的optId
     * @param optId {string}
     */
    setOptId(optId) {
        if (typeof optId !== 'string' || !optId.length) {
            return;
        }
        this._optId = optId;
    }

    /**
     * 获取调试模式状态
     * @returns {boolean|*}
     */
    getDebugMode() {
        return this._debugMode;
    }

    /**
     * 设置调试模式状态
     * @param debugMode {boolean}
     */
    setDebugMode(debugMode) {
        if (typeof debugMode !== 'boolean') {
            return;
        }
        this._debugMode = debugMode;
    }

    /**
     * 设置应用名称
     * @param appType {number}
     */
    setAppType(appType) {
        if (typeof appType !== 'number') {
            return;
        }
        this._appType = appType;
    }

    /**
     * 设置登录id
     * @param loginId {string}
     */
    setLoginId(loginId) {
        if (typeof loginId !== 'string') {
            return;
        }
        this._loginId = loginId;
    }

    /**
     * 添加聚合url
     * @param url {string}
     */
    addClusterUrl(url) {
        if (typeof url !== 'string') {
            return;
        }
        this._conf.clusterUrls.push(url);
    }

    /**
     * 移除聚合url
     * @param url {string}
     */
    removeClusterUrl(url) {
        if (typeof url !== 'string') {
            return;
        }
        const urlIndex = this._conf.clusterUrls.indexOf(url);
        if (urlIndex !== -1) {
            this._conf.clusterUrls.splice(urlIndex, 1);
        }
    }

    /**
     * 设置路径映射
     * @param from {string} 源路径
     * @param to {string} 目标路径
     */
    setUrlMap(from, to) {
        if (typeof from !== 'string' || typeof to !== 'string') {
            return;
        }
        this._conf.urlMap[from] = to;
    }

    /**
     * 移除路径映射
     * @param from {string} 源路径
     */
    removeUrlMap(from) {
        if (typeof from !== 'string') {
            return;
        }
        delete this._conf.urlMap[from];
    }

    /**
     * 记录日志
     * @param param {object}
     */
    log(param) {
        try {
            if (!this._on) {
                return;
            }
            if (this._debugMode) {
                console.log('ApmLog log', param);
            }
            if (typeof param !== 'object' || typeof param.segment !== 'object') {
                if (this._debugMode) {
                    console.error('ApmLog param error', param);
                }
                return;
            }
            param.optId = param.optId || this._optId;
            param.pageUrl = this._updateUrl(param.pageUrl || this._currentPath());
            param.segment.time = param.segment.time || Date.now();
            param.segment.segId = param.segment.segId || `${param.segment.segType}${param.optId}`;
            const store = this._getSessionStorage('apmStore') || {};
            const opt = store[param.optId] || {};
            let seg = opt[param.segment.segId] || [];
            seg.push(param);
            seg = this._cluster(seg);
            if (seg.length) {
                opt[param.segment.segId] = seg;
            } else { // 当前segId下的log已全部聚合发送，从opt中移除
                delete opt[param.segment.segId];
            }
            if (Object.keys(opt).length) {
                store[param.optId] = opt;
            } else { // 当前optId下的log已全部聚合发送，从store中移除
                delete store[param.optId];
            }
            this._setSessionStorage('apmStore', store);
        } catch (err) {
            if (this._debugMode) {
                console.error('ApmLog log catch error', err);
            }
        }
    }

    /**
     * 记录网络请求时长日志（便捷方法）
     * @param optId {string} 操作id
     * @param reqId {string} 请求id
     * @param url {string} 请求地址
     * @param timeType {number} 时间类型，0表示开始，1表示结束
     * @param pageUrl {string} 页面地址
     */
    logRequest(optId, reqId, url, timeType, pageUrl = undefined) {
        if (!optId || !reqId || !url || (+timeType !== 0 && +timeType !== 1)) {
            if (this._debugMode) {
                console.error('ApmLog logRequest param error', optId, reqId, url, timeType);
            }
            return;
        }
        const log = {
            segment: {
                optId,
                segId: reqId,
                segType: 'apmnt',
                timeType,
                tags: {
                    url
                }
            }
        };
        if (pageUrl) {
            log.pageUrl = pageUrl;
        }
        this.log(log);
    }

    /**
     * 记录可感知时长日志（便捷方法）
     * @param timeType {number} 时间类型，0表示开始，1表示结束
     * @param pageUrl {string} 页面地址
     */
    logTotal(timeType, pageUrl = undefined) {
        if (+timeType !== 0 && +timeType !== 1) {
            if (this._debugMode) {
                console.error('ApmLog logTotal param error', timeType);
            }
            return;
        }
        const log = {
            segment: {
                segType: 'tt',
                timeType
            }
        };
        if (pageUrl) {
            log.pageUrl = pageUrl;
        }
        this.log(log);
    }

    /**
     * 记录静态资源时长（便捷方法）
     * @param timeType {number} 时间类型，0表示开始，1表示结束
     * @param pageUrl {string} 页面地址
     */
    logStatic(timeType, pageUrl = undefined) {
        if (+timeType !== 0 && +timeType !== 1) {
            if (this._debugMode) {
                console.error('ApmLog logStatic param error', timeType);
            }
            return;
        }
        const log = {
            segment: {
                segType: 'stt',
                timeType
            }
        };
        if (pageUrl) {
            log.pageUrl = pageUrl;
        }
        this.log(log);
    }

    /**
     * 记录网络请求总时长日志（便捷方法）
     * @param timeType {number} 时间类型，0表示开始，1表示结束
     * @param pageUrl {string} 页面地址
     */
    logServer(timeType, pageUrl = undefined) {
        if (+timeType !== 0 && +timeType !== 1) {
            if (this._debugMode) {
                console.error('ApmLog logServer param error', timeType);
            }
            return;
        }
        const log = {
            segment: {
                segType: 'st',
                timeType
            }
        };
        if (pageUrl) {
            log.pageUrl = pageUrl;
        }
        this.log(log);
    }

    /**
     * 记录渲染时长日志（便捷方法）
     * @param timeType {number} 时间类型，0表示开始，1表示结束
     * @param pageUrl {string} 页面地址
     */
    logRender(timeType, pageUrl = undefined) {
        if (+timeType !== 0 && +timeType !== 1) {
            if (this._debugMode) {
                console.error('ApmLog logRender param error', timeType);
            }
            return;
        }
        const log = {
            segment: {
                segType: 'rt',
                timeType
            }
        };
        if (pageUrl) {
            log.pageUrl = pageUrl;
        }
        this.log(log);
    }

}

module.exports = Apm;
